import { Badge, Button, DialogBody, FormatNumber, Grid, GridItem, HStack, Stack, Text } from "@chakra-ui/react";
import { useQueryClient } from "@tanstack/react-query";
import { UI } from "components";
import { API } from "config";
import { toaster } from "config";
import { Styles } from "config";
import moment from "moment";
import { useState } from "react";

export default function Activate({ data, ...props}){

    const queryClient = useQueryClient()
    const [ error, setError ] = useState(false)
    const [ loading, setLoading ] = useState(false) 

    const kit = data?.itens?.[0].product_kit ?? {}
    const status = Styles.orderStatus(data?.status)

    const handleActivate = async () => {
        setLoading(true)

        try{
            await API.post(`/activate/${data.cod}`)
            toaster.create({ title: 'O consultor foi ativado com sucesso!', type: 'success' })
            queryClient.invalidateQueries('vouchers')
            props.onClose()
            setLoading(false)
        }catch(err){
            setError(err?.response?.data?.message)
            toaster.create({ title: 'Não foi possível realizar a ativação.', description: err?.response?.data?.message, type: 'warning' })
            setLoading(false)
        }
    }

    return(
    <UI.Dialog title={`Ativar pedido #${data?.cod}`} loading={loading} {...props}>
        <DialogBody>
            <Stack gap={4}>

                <Grid templateColumns="repeat(2, 1fr)" gap={4}>
                    
                    <GridItem>
                        <Text color="GrayText">Status:</Text>
                        <Badge size="lg" colorPalette={status.colorPalette}>{data?.status_label}</Badge>
                    </GridItem>

                    <GridItem>
                        <Text color="GrayText">Kit:</Text>
                        <Text fontSize="md" fontWeight="bold">{kit.label}</Text>
                        <Badge size="sm" colorPalette="purple"><FormatNumber style="currency" currency="BRL" value={kit.sale_price / 100} /></Badge>
                    </GridItem>

                    <GridItem colSpan={2}>
                        <Text color="GrayText">Consultor:</Text>
                        <HStack>
                            <UI.Avatar size="xs" name={data?.consultant?.customer?.name} />
                            <Text fontSize="md" fontWeight="bold">{data?.consultant?.customer?.name}</Text>
                        </HStack>
                    </GridItem>

                    <GridItem>
                        <Text color="GrayText">Data do pedido:</Text>
                        <Text>{moment(data?.created_at).format('LLL')}</Text>
                    </GridItem>

                </Grid>

                <UI.Alert size="sm" colorPalette="purple">Para realizar esta ativação, você utilizará 1 unidade do voucher <b>{kit.label}</b>.</UI.Alert>
                
                <Button size="lg" colorPalette="purple" loading={loading} loadingText="Ativando consultor..." onClick={handleActivate}>Ativar com voucher</Button>

            </Stack>

        </DialogBody>
    </UI.Dialog>
    )
}